import { html } from 'htm/preact';
import { useState } from 'preact/hooks';

import { track } from '../../utils/tracking';

import Button from './Button';
import ConfirmDialog from './ConfirmDialog';
import Header from './Header';
import SectionDivider from './SectionDivider';
import SectionHeader from './SectionHeader';
import SelectSimple from './SelectSimple';
import instructions from './instructions.json';

const StepNumber = ({ onSelectedTransfer, onSelectedNew, customerId, isPortinOnly, isNewOnly }) => {
  const [zip, setZip] = useState('');
  const [isNewConfirmOpen, setIsNewConfirmOpen] = useState(false);

  const networks = instructions.map((instruction) => ({
    value: instruction.title,
    label: instruction.title,
  }));

  // Portin Numner
  const handleTransfer = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const network = formData.get('network');
    const networkInstructions = instructions.find((instruction) => instruction.title === network);
    onSelectedTransfer(networkInstructions);
  };

  const handleSkipCarrier = (e) => {
    e.preventDefault();

    track('activation_skip_carrier', { userId: customerId });

    const networkInstructions = instructions.find((instruction) => instruction.title.includes('Other'));
    onSelectedTransfer(networkInstructions);
  };

  // Get New Number
  const handleGetNew = (e) => {
    e.preventDefault();
    setIsNewConfirmOpen(true);
  };

  const handleGetNewConfirmed = () => {
    setIsNewConfirmOpen(false);
    onSelectedNew({
      isNew: true,
      zip,
    });    
  };

  const handleGetNewCanceled = () => {
    setIsNewConfirmOpen(false);
  };

  let title = 'Transfer Your Current Number or get a new one';
  let description = 'You have two easy options to check your device.';
  let bothOptionsVisible = !isPortinOnly && !isNewOnly;

  if (isPortinOnly) {
    title = 'Transfer Your Current Number';
    description = 'Switching is simple! Most transfers complete within a few hours, though some may take up to 48 hours.';
  }

  if (isNewOnly) {
    title = 'Get a new Number';
    description = 'We\'ll give you a new phone number based on your ZIP Code.';
  }

  return html`
    <${Header}
      title=${title}
      description=${description}
    />
    <div class="flex flex-col lg:flex-row gap-6 lg:gap-12 mb-8">
      ${!isNewOnly && html`
        <div class="flex flex-col items-center w-full ${bothOptionsVisible ? 'lg:w-1/2' : 'max-w-sm'}">
          <form onSubmit=${handleTransfer} class="flex flex-col items-center">
            <${SectionHeader}
              title="Keep Your current number"
              description="It typically takes just a few hours but can take up to 48 hours."
              icon="phone"
            />
            <${SelectSimple} name="network" placeholder="Select your current carrier" options=${networks} required />
            <button class="mt-1 mb-2 text-gray-500 text-xs transition hover-line-visible" onClick=${handleSkipCarrier}>
              Can't find your carrier?
            </button>
            <${Button}
              text="Transfer Your Number"
              className="mt-2"
            />
          </form>
        </div>
      `}
      ${bothOptionsVisible && html`
        <${SectionDivider} />
      `}
      ${!isPortinOnly && html`
        <div class="flex flex-col items-center w-full ${bothOptionsVisible ? 'lg:w-1/2' : 'max-w-sm'}">
          <form onSubmit=${handleGetNew} class="flex flex-col items-center">
            <${SectionHeader}
              title="Get a new Number"
              description="We’ll give you a new phone number based on your ZIP Code."
              icon="hotspot"
            />
            <input
              type="text"
              name="imei"
              placeholder="Enter Your ZIP Code"
              class="mb-2 w-72 h-14 rounded-xl text-center lg:text-sm appearance-none bg-white"
              minlength="5"
              maxlength="5"
              value=${zip}
              onInput=${(e) => setZip(e.target.value)}
              required
            />
            <${Button}
              text="Get Your New Number"
              className="mt-2"
            />
          </form>
        </div>
      `}
    </div>
    <${ConfirmDialog}
      title="Are you sure you want to get a new number with this ZIP code?"
      description="You won't be able to change it if you proceed."
      confirmText="Get New Number"
      dismissText="Go Back"
      onConfirm=${handleGetNewConfirmed}
      onCancel=${handleGetNewCanceled}
      isOpen=${isNewConfirmOpen}
    />
  `;
};

export default StepNumber;
